import { useState } from 'react';

/**
 * Shared hook for managing an expand/collapse Set of item IDs.
 * Used by RoleList and UserList.
 */
function useExpandedSet(items) {
  const [expandedIds, setExpandedIds] = useState(new Set());

  const allExpanded = items.length > 0 && items.every((item) => expandedIds.has(item.id));

  const toggleAll = (event) => {
    event.stopPropagation();
    setExpandedIds(allExpanded ? new Set() : new Set(items.map((item) => item.id)));
  };

  const toggleOne = (id) => {
    setExpandedIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  return { expandedIds, allExpanded, toggleAll, toggleOne };
}

export default useExpandedSet;
